var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66675C5.40435 1.66675 1.66602 5.40508 1.66602 10.0001V13.4526C1.66602 14.3059 2.41352 15.0001 3.33268 15.0001H4.16602C4.38703 15.0001 4.59899 14.9123 4.75527 14.756C4.91155 14.5997 4.99935 14.3878 4.99935 14.1667V9.88091C4.99935 9.6599 4.91155 9.44794 4.75527 9.29166C4.59899 9.13538 4.38703 9.04758 4.16602 9.04758H3.40935C3.87268 5.82258 6.64768 3.33341 9.99935 3.33341C13.351 3.33341 16.126 5.82258 16.5893 9.04758H15.8327C15.6117 9.04758 15.3997 9.13538 15.2434 9.29166C15.0871 9.44794 14.9993 9.6599 14.9993 9.88091V15.0001C14.9993 15.9192 14.2518 16.6667 13.3327 16.6667H11.666V15.8334H8.33268V18.3334H13.3327C15.171 18.3334 16.666 16.8384 16.666 15.0001C17.5852 15.0001 18.3327 14.3059 18.3327 13.4526V10.0001C18.3327 5.40508 14.5943 1.66675 9.99935 1.66675Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.0b1d3eeec2c3d8e9093e540ff0fa9868.svg";
export { ForwardRef as ReactComponent };